import { useEffect, useState, useContext, useRef, useCallback, useMemo } from "react";
import { request } from "../../functions/request";
import { ligarAtalhos } from "../../functions/atalhosTexto";
import { Button, Descriptions, Image, Input, Select, Space, Radio, Checkbox, DatePicker, Modal, Typography, Alert } from "antd";
import dayjs from "dayjs";
import {
  formatDateToBR,
  optionsTag
} from "../../functions/functionsUtility";
import { toast } from "react-toastify";
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import Aguarde from "../../components/aguarde/aguarde";
import { Content } from "antd/es/layout/layout";
import { LuStarOff, LuStar } from "react-icons/lu";
import { UploadOutlined, DeleteOutlined, ExportOutlined, UpOutlined, DownOutlined, ClockCircleOutlined, CloseOutlined, ZoomInOutlined, ZoomOutOutlined, LineChartOutlined, FileTextOutlined } from "@ant-design/icons";
import { FaSave, FaTrash, FaUpload, FaCalendarCheck, FaArrowAltCircleUp } from "react-icons/fa";
import { BsCloudRainHeavy } from "react-icons/bs";
import { AuthContext } from "../../context/AuthContext";
import JoditEditor from "jodit-react";
import DrawerImages from "../../components/ui/Drawer/DrawerImages";
import { min } from "moment";
import { openPopupEditor, openReportPopupAndCapture, limparColagemDeLinhas, removerParagrafos, normalizarParaEditor } from "../../functions/utils";

const REPORT_CHART_SOURCES = [
  { key: "comex", label: "Gráfico Comex", path: "/relatorios/comex-graficos" },
  { key: "usda", label: "Gráfico USDA", path: "/relatorios/usda" },
  { key: "usda-nass", label: "Gráfico USDA NASS", path: "/relatorios/usda-nass" },
  { key: "cot", label: "Posição dos Fundos (COT)", path: "/relatorios/cot" },
  { key: "ipar", label: "Gráficos IPAR", path: "/central-de-graficos" },
  { key: "gerador", label: "Gerar Gráfico", path: "/graficos/gerador" },
];

const optionsSection = [
  { value: false, label: "Todos" },
  { value: 1, label: "Boi" },
  { value: 2, label: "Frango" },
  { value: 3, label: "Grãos" },
  { value: 4, label: "Leite" },
  { value: 5, label: "Suinos" },
  { value: 8, label: "Agroações" },
  { value: 9, label: "Bolsas e Opções" },
];

const LOCAL_STORAGE_KEY = "editorNoticiaDraft";
const ZOOM_LEITURA_KEY = "editorRTE_zoomLeitura";

function EditorNoticia() {
  const [data, setData] = useState(null);
  const [content, setContent] = useState("");
  const [titlePage, setTitlePage] = useState("");
  const [title, setTitle] = useState("");
  const [tag, setTag] = useState("");
  const [lead1, setLead1] = useState("");
  const [lead2, setLead2] = useState("");
  const [secao, setSecao] = useState("");
  const [importancia, setImportancia] = useState("0"); // Alteração aqui
  const [optionsAdicional, setOptionsAdicional] = useState({
    Destaque: false,
    Aprovado: false,
    /*Espanhol: false,
    Tv: false,
    "Rel.Research": false,
    "Rural Biz(G:30)(C:20)": false,*/
  });
  const [drawer, setDrawer] = useState({
    isOpen: false,
    data: null,
  });
  const [formattedDate, setFormattedDate] = useState("");
  const [notImagem, setNotImagem] = useState(null);
  const [fieldsCollapsed, setFieldsCollapsed] = useState(false);
  const [reportPickerOpen, setReportPickerOpen] = useState(false);
  const [capturedChartHtml, setCapturedChartHtml] = useState(null);
  const [modeloPickerOpen, setModeloPickerOpen] = useState(false);
  const [modelos, setModelos] = useState([]);
  const [buscaModelo, setBuscaModelo] = useState("");
  const buscaModeloRef = useRef(null);
  const [agendado, setAgendado] = useState(false);
  const [showScheduler, setShowScheduler] = useState(false);
  const [scheduleDate, setScheduleDate] = useState(null);
  const editorRef = useRef(null);

  // Zoom de leitura do editor: só aumenta/diminui visualmente o conteúdo
  // (via CSS "zoom" na área de edição do Jodit), não mexe no HTML/font-size
  // salvo — é só conforto de leitura de quem está escrevendo/revisando.
  // Preferência é lembrada entre sessões (mesma chave nos dois editores).
  const [zoomLevel, setZoomLevel] = useState(() => {
    try {
      const saved = parseInt(localStorage.getItem(ZOOM_LEITURA_KEY), 10);
      return Number.isFinite(saved) ? saved : 100;
    } catch {
      return 100;
    }
  });
  useEffect(() => {
    try {
      localStorage.setItem(ZOOM_LEITURA_KEY, String(zoomLevel));
    } catch {}
  }, [zoomLevel]);

  // Altura da barra de botões varia (quebra pra 2+ linhas em telas
  // estreitas, já que tem flexWrap) — mede de verdade com ResizeObserver e
  // publica numa CSS var em vez de um "top" fixo, senão o toolbar do Jodit
  // (que fica sticky logo abaixo, via CSS) acaba ficando embaixo da barra
  // quando ela cresce.
  const actionBarRef = useRef(null);
  useEffect(() => {
    const el = actionBarRef.current;
    if (!el || typeof ResizeObserver === "undefined") return;
    const updateHeight = () => {
      document.documentElement.style.setProperty(
        "--rb-action-bar-height",
        `${el.offsetHeight}px`
      );
    };
    updateHeight();
    const observer = new ResizeObserver(updateHeight);
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  // Atalhos de texto: mapa {atalho -> conteudo} carregado uma vez e mantido
  // num ref (não precisa re-renderizar nada quando muda, só precisa estar
  // sempre atualizado no momento em que o usuário digita).
  const atalhosRef = useRef({});
  useEffect(() => {
    request("/atalho/getAtalhosAtivos", { method: "GET" })
      .then((lista) => {
        const mapa = {};
        (lista || []).forEach((a) => {
          mapa[a.atl_atalho.toLowerCase()] = a.atl_conteudo;
        });
        atalhosRef.current = mapa;
      })
      .catch((err) => console.log("Erro ao carregar atalhos de texto:", err));
  }, []);

  // "/atalho" + espaço ou Enter troca pelo conteúdo cadastrado (lógica
  // compartilhada com o outro editor em functions/atalhosTexto.js).
  // Precisa ser estável (useCallback) — o jodit-react re-cria a instância do
  // editor sempre que a prop editorRef muda de identidade entre renders.
  const setEditorInstance = useCallback((instance) => {
    editorRef.current = instance;
    ligarAtalhos(instance, () => atalhosRef.current, (html) => {
      if (typeof html === "string") setContent(html);
    });
    if (instance?.e) {
      instance.e.off("beforePasteInsert", limparColagemDeLinhas);
      instance.e.on("beforePasteInsert", limparColagemDeLinhas);
    }
  }, []);
  const navigate = useNavigate();
  const { search } = useLocation();
  const { accessLevel } = useContext(AuthContext);

  const [isLoading, setIsLoading] = useState(false);
  const [URLSearchParams] = useSearchParams();
  const { id } = useParams();
  const isUpdating = !!URLSearchParams.get("section");
  const isPopup = URLSearchParams.get("popup") === "1";

  const STORAGE_KEY = LOCAL_STORAGE_KEY;

  useEffect(() => {
    if (!isUpdating && !id) {
      setTitlePage("Inserir Notícia");
    } else {
      setTitlePage(
        `Editar Notícia de ${optionsSection.find((option) => {
          return option.value === secao;
        })?.label
        }`
      );
    }
  }, [secao, id, isUpdating]);

  useEffect(() => {
    const fetchTableData = async () => {
      try {
        const currentPathWithQuery = id
          ? "/noticia/getnoticia/" + id
          : isUpdating
            ? "/noticia/getnoticia/" + search
            : "/editor-noticia" + search;

        if (!isUpdating && !id) {
          setData(null);
          setTitle("");
          setSecao("");
          setContent("");
          setFormattedDate("");
          setIsLoading(false);
          setNotImagem(null);
          setAgendado(false);
          setShowScheduler(false);
          setScheduleDate(null);
          setOptionsAdicional({
            Destaque: false,
            Aprovado: false,
            /*Espanhol: false,
            Tv: false,
            "Rel.Research": false,
            "Rural Biz(G:30)(C:20)": false,*/
          });
          setTitlePage("Inserir Nova Notícia");
          setTag("");
          setLead1("");
          setLead2("");
          setSecao("");
          setImportancia("0");
          return;
        }

        const response = await request(currentPathWithQuery, {
          method: "GET",
        });

        if (response.length === 0) {
          navigate("/noticia");
        }

        setTitlePage("Editar Notícia");

        console.log("response onEdit:", response);

        setData(response[0]);

        setContent(normalizarParaEditor(response[0]?.not_texto || ""));

        setTitle(response[0]?.not_titulo || "");

        setSecao(response[0]?.not_secao || "");

        setTag(response[0]?.not_tag || "");

        setLead1(response[0]?.not_lead || "");

        setLead2(response[0]?.not_lead_curto || "");

        setOptionsAdicional({
          Destaque: response[0]?.not_destaque === 1,
          Aprovado: response[0]?.not_aprovado === 1,
          /*Espanhol: response[0]?.not_espanhol === 1,
          Tv: response[0]?.not_tv === 1,
          "Rel.Research": response[0]?.not_relresearch === 1,
          "Rural Biz(G:30)(C:20)": response[0]?.not_biz === 1,*/
        });

        setImportancia(response[0]?.nivel.toString() || "0");

        const date = new Date(response[0]?.not_data);

        setFormattedDate(
          `${formatDateToBR(date)} às ${date.getHours()}:${date.getMinutes()}`
        );
        setAgendado(response[0]?.not_agendado === true || response[0]?.not_agendado === 1);
        setScheduleDate(response[0]?.not_data ? dayjs(response[0]?.not_data) : null);

        await request(`/imagem/getImagemByCodigo/${response[0]?.not_imagem}`, {
          method: "GET",
        }).then((res) => {
          console.log(res);
          setNotImagem((prevState) => ({
            ...prevState,
            key: response[0]?.not_imagem,
            img_arquivo: res[0]?.img_arquivo ?? null,
          }));
        });
      } catch (error) {
        console.error("Erro na requisição:", error);
      }
    };
    fetchTableData();
  }, [search, id, isUpdating, navigate]);

  useEffect(() => {
    if (!id && !isUpdating) {
      const savedDraft = localStorage.getItem(STORAGE_KEY);
      if (savedDraft) {
        try {
          const parsed = JSON.parse(savedDraft);
          setTitle(parsed.title || "");
          setSecao(parsed.secao || "");
          setContent(parsed.content || "");
          setTag(parsed.tag || "");
          setLead1(parsed.lead1 || "");
          setLead2(parsed.lead2 || "");
          setImportancia(parsed.importancia || "0");
          setOptionsAdicional(parsed.optionsAdicional || {
            Destaque: false, 
            Aprovado: false,
            /*Espanhol: false,
            Tv: false,
            "Rel.Research": false,
            "Rural Biz(G:30)(C:20)": false,*/
          });
          setNotImagem(parsed.notImagem || null);
          console.log("Rascunho carregado do localStorage:", parsed);
        } catch (e) {
          console.warn("Erro ao carregar rascunho do localStorage", e);
        }
      }
    }
  }, [STORAGE_KEY, id, isUpdating]);

  useEffect(() => {
    if (!id && !isUpdating) {
      const draft = {
        title,
        secao,
        content,
        tag,
        lead1,
        lead2,
        importancia,
        optionsAdicional,
        notImagem,
      };
      if (draft) localStorage.setItem(STORAGE_KEY, JSON.stringify(draft));
    }
  }, [id, isUpdating, STORAGE_KEY, title, secao, content, tag, lead1, lead2, importancia, optionsAdicional, notImagem]);

  const handleSave = (ativo, options = {}) => {
    const { agendar = false, dataAgendada = null, aoConcluir = null } = options;

    if (agendar && !dataAgendada) {
      toast.error("Selecione a data e hora do agendamento!");
      return;
    }

    // Editar uma notícia EXISTENTE que ainda não está no ar (aprovação ou
    // agendada) não pode ativá-la sozinha: o único botão disponível ao
    // abrir uma matéria em aprovação é este mesmo ("Atualizar"), e sem essa
    // guarda, corrigir um typo e clicar nele publicava a matéria na hora,
    // com a data de hoje — quem decide publicar é a lista ("Publicar"/
    // "Aprovar"), o agendamento, ou o botão dedicado "Publicar Agora"
    // (que também passa por aqui, mas conclui a ativação de verdade via
    // aoConcluir/publicarAgoraNoticia, então preservar o estado aqui não
    // atrapalha esse fluxo).
    const eraAtiva = data?.not_ativo === true || data?.not_ativo === 1;
    const preservarStatus = formattedDate && !agendar && !eraAtiva;

    // A data de publicação só é escrita quando ela realmente muda: matéria
    // nova (agora) e agendamento (a data escolhida). EDITAR uma matéria que
    // já existe não mexe na data — nem a que está no ar, nem a que aguarda
    // aprovação. Antes, salvar uma matéria já publicada mandava dayjs() e
    // carimbava a hora da edição por cima da hora original, jogando a
    // matéria para o topo da listagem do site como se fosse nova.
    //
    // Omitir o campo, em vez de reenviar o valor atual, é de propósito:
    // o updateNoticia só toca nas colunas que chegam (verifyUpdateNoticia),
    // então a coluna nem é escrita — sem ida e volta de fuso para estragar
    // a hora no caminho.
    const editando = Boolean(formattedDate);
    const dataFinal = agendar ? dataAgendada : editando ? null : dayjs();

    const newData = {
      not_titulo: title.trim().replace(/\s+/g, " "),
      not_lead: lead1.trim().replace(/\s+/g, " "),
      not_lead_curto: lead2.trim().replace(/\s+/g, " "),
      not_secao: secao,
      nivel: importancia,
      not_site: 0,
      not_estacao: 0,
      not_espanhol: optionsAdicional["Espanhol"] || 0,
      not_biz: optionsAdicional["Rural Biz(G:30)(C:20)"]  || 0,
      not_tv: optionsAdicional["Tv"]  || 0,
      not_destaque: optionsAdicional["Destaque"],
      not_relresearch: optionsAdicional["Rel.Research"]  || 0,
      not_tag: tag,
      not_imagem: notImagem?.key || null,
      not_texto: removerParagrafos(content) || "",
      not_ativo: agendar ? 0 : preservarStatus ? 0 : ativo,
      not_aprovado: optionsAdicional["Aprovado"],
      not_agendado: agendar
        ? 1
        : preservarStatus
        ? (data?.not_agendado === true || data?.not_agendado === 1 ? 1 : 0)
        : 0,
      ...(dataFinal ? { not_data: dayjs(dataFinal).format("YYYY-MM-DD HH:mm:ss") } : {}),
    };

    if (newData.not_titulo === "" || newData.not_texto === "" || !secao) {
      toast.error("Preencha o Título, Notícia e Seção!");
      return;
    }

    let currentPathWithQuery;

    if (formattedDate) {
      currentPathWithQuery = `/noticia/updateNoticia/${data?.not_numero}`;
    } else {
      currentPathWithQuery = `/noticia/insertNoticia`;
    }

    console.log("newData:", newData);
    request(currentPathWithQuery, {
      method: "POST",
      body: JSON.stringify({ newData: newData }),
    }).then(() => {
      localStorage.removeItem(STORAGE_KEY); // deletes the draft from localStorage
      setShowScheduler(false);

      // "Publicar Agora" encadeia aqui: o texto já foi gravado, agora o
      // servidor carimba a publicação. O toast fica por conta dele.
      if (aoConcluir) {
        return Promise.resolve(aoConcluir()).finally(() => refreshPage());
      }

      toast.success(
        agendar
          ? `Notícia agendada para ${dayjs(dataFinal).format("DD/MM/YYYY HH:mm")}!`
          : "Notícia salva com sucesso!"
      );
      refreshPage();
    });
  };

  /**
   * Publica na hora uma notícia que estava agendada.
   *
   * Salva o texto atual antes (mantendo o agendamento) e só então publica,
   * para que a versão que está na tela seja a que vai ao ar.
   *
   * Quem carimba a data é o SERVIDOR, pelo endpoint publicarAgoraNoticia.
   * O resto deste editor grava not_data a partir do relógio do navegador,
   * o que deixaria a hora da postagem dependente da máquina de quem
   * clicou — a lista de agendadas e o editor de análise já usam a hora do
   * servidor, e as três precisam concordar.
   */
  const handlePublicarAgora = () => {
    if (
      !window.confirm(
        "Publicar esta notícia agora? A data passa a ser a de agora e o agendamento é cancelado."
      )
    )
      return;

    handleSave(0, {
      aoConcluir: () =>
        request(`/noticia/publicarAgoraNoticia/${data?.not_numero}`, {
          method: "PUT",
        }).then(() => {
          toast.success("Notícia publicada agora!");
          setAgendado(false);
        }),
    });
  };

  const deleteItem = () => {
    const currentPathWithQuery = `/noticia/deleteNoticia/${data?.not_numero}`;
    if (window.confirm("Deseja realmente apagar esta notícia?")) {
      request(currentPathWithQuery, {
        method: "DELETE",
      }).then(() => {
        toast.success("Analise deletada com sucesso!");
        refreshPage("/editor-noticia/");
      });
    }
  };

  function refreshPage(path = 0, timeout = 1000) {
    setTimeout(() => {
      navigate(path, { replace: true });
    }, timeout);
  }

  const handleTitleChange = (event) => {
    setTitle(event.target.value);
  };

  const handleSecaoChange = (value) => {
    setSecao(value);
  };

  const handleTagChange = (value) => {
    setTag(value);
  };

  const handleImportanciaChange = (e) => {
    setImportancia(e.target.value);
  };

  const handleLead1Change = (event) => {
    setLead1(event.target.value);
  };

  const handleLead2Change = (event) => {
    setLead2(event.target.value);
  };

  const openPopup = () => {
    const popup = window.open(
      "/multimidia/banco_imagens_popup",
      "",
      "popup,width=925,height=600"
    );

    window.onChooseImage = (data) => {
      setNotImagem(data);
      popup.close();
    };
  };

  const onClearImage = () => {
    setNotImagem(null);
  };

  // Mesma base (banco de imagens) do "Escolher imagem", mas insere no corpo
  // da notícia em vez de definir a capa — pode ser usado quantas vezes precisar.
  const insertIntoBody = (html) => {
    const jodit = editorRef.current;
    if (jodit?.s) {
      // O Jodit sempre joga conteúdo em BLOCO (div/iframe/p) pro final do
      // editor, ignorando o cursor — só respeita a posição pra conteúdo
      // inline. Contorna isso inserindo um marcador inline no cursor (que É
      // respeitado) e depois trocando ele pelo HTML real direto no DOM.
      const markerId = `rb-insert-marker-${Date.now()}-${Math.random().toString(36).slice(2, 7)}`;
      jodit.s.insertHTML(`<span id="${markerId}">​</span>`);
      const marker = document.getElementById(markerId);
      if (marker) {
        marker.outerHTML = html;
      } else {
        jodit.s.insertHTML(html);
      }
      if (typeof jodit.value === "string") {
        setContent(jodit.value);
      }
    } else {
      setContent((prev) => (prev || "") + html);
    }
  };

  const openPopupForGrafico = () => {
    const popup = window.open(
      "/multimidia/banco_imagens_popup",
      "",
      "popup,width=925,height=600"
    );

    window.onChooseImage = (data) => {
      const url = `${process.env.REACT_APP_BANCO_IMG_URL}${data.img_arquivo}`;
      const html = `<p><img src="${url}" alt="${data.img_nome || ""}" style="max-width:100%;" /></p>`;
      // Mesma correção do "Gráfico de Relatório": não insere direto, deixa o
      // usuário escolher Inserir (no cursor salvo antes de abrir o popup) ou
      // só Copiar.
      setCapturedChartHtml(html);
      setReportPickerOpen(true);
      popup.close();
    };
  };

  const handleInsertReportChart = (html) => {
    // Não insere direto — guarda o código e deixa o usuário escolher Inserir
    // (no cursor salvo antes de abrir a janela do relatório) ou só Copiar.
    setCapturedChartHtml(html);
    setReportPickerOpen(true);
  };

  const CURSOR_ANCHOR_ID = "rb-cursor-anchor";

  // mousedown (não click) porque o próprio clique já tira o foco/seleção do
  // editor antes do handler de click rodar — precisa marcar a posição do
  // cursor ANTES disso acontecer. Usa um marcador inline de verdade no DOM
  // (não o save()/restore() do Jodit — não sobrevive de forma confiável à
  // troca de foco pra janela do relatório e de volta).
  const saveEditorCursor = () => {
    document.getElementById(CURSOR_ANCHOR_ID)?.remove();
    editorRef.current?.s?.insertHTML(`<span id="${CURSOR_ANCHOR_ID}">​</span>`);
  };

  const openReportPicker = () => {
    setReportPickerOpen(true);
  };

  const openReportChartSource = (path) => {
    setReportPickerOpen(false);
    openReportPopupAndCapture(path, handleInsertReportChart);
  };

  const confirmInsertReportChart = () => {
    if (!capturedChartHtml) return;
    const anchor = document.getElementById(CURSOR_ANCHOR_ID);
    if (anchor) {
      anchor.outerHTML = capturedChartHtml;
      if (typeof editorRef.current?.value === "string") {
        setContent(editorRef.current.value);
      }
    } else {
      insertIntoBody(capturedChartHtml);
    }
    toast.success("Gráfico adicionado à matéria!");
    setCapturedChartHtml(null);
    setReportPickerOpen(false);
  };

  const confirmCopyReportChart = () => {
    if (!capturedChartHtml) return;
    navigator.clipboard.writeText(capturedChartHtml)
      .then(() => toast.success("Código copiado para a área de transferência!"))
      .catch(() => toast.error("Erro ao copiar."));
  };

  const closeReportPicker = () => {
    document.getElementById(CURSOR_ANCHOR_ID)?.remove();
    setCapturedChartHtml(null);
    setReportPickerOpen(false);
  };

  const openModeloPicker = async () => {
    try {
      const result = await request("/modelo/getModelosAtivos?tipo=noticia", {
        method: "GET",
      });
      setModelos(result || []);
      setBuscaModelo("");
      setModeloPickerOpen(true);
    } catch (error) {
      console.log(error);
      toast.error("Erro ao buscar modelos de matéria.");
    }
  };

  const semAcento = (texto) =>
    String(texto || "")
      .normalize("NFD")
      .replace(/[̀-ͯ]/g, "")
      .toLowerCase();

  const modelosFiltrados = useMemo(() => {
    const termo = semAcento(buscaModelo).trim();
    if (!termo) return modelos;
    return modelos.filter((m) => semAcento(m.mod_nome).includes(termo));
  }, [modelos, buscaModelo]);

  const closeModeloPicker = () => {
    setModeloPickerOpen(false);
  };

  const aplicarModelo = (html) => {
    setContent(html);
    toast.success("Modelo aplicado à matéria!");
    setModeloPickerOpen(false);
  };

  const chooseModelo = (modelo) => {
    const hasContent = content && content.replace(/<[^>]*>/g, "").trim().length > 0;
    if (hasContent) {
      Modal.confirm({
        title: "Substituir conteúdo?",
        content:
          "Isso vai substituir todo o conteúdo atual do editor pelo modelo escolhido. Deseja continuar?",
        okText: "Substituir",
        cancelText: "Cancelar",
        onOk: () => aplicarModelo(modelo.mod_conteudo),
      });
    } else {
      aplicarModelo(modelo.mod_conteudo);
    }
  };

  // Config precisa de identidade estável entre renders — o jodit-react
  // destrói e recria a instância inteira do editor sempre que a referência
  // de `config` muda (efeito com deps [config, editorRef]). Como o onBlur
  // chama setContent (causando re-render), um objeto inline aqui fazia o
  // editor ser recriado toda vez que perdia o foco, resetando o scroll pro
  // topo e perdendo o lugar onde se estava editando.
  const joditConfig = useMemo(
    () => ({
      askBeforePasteHTML: true,
      //style: { fontFamily: "Arial" },
      language: "pt_br",
      // enter:"br" foi tentado aqui pra desabilitar o uso de <p> ao dar
      // Enter, mas causa perda de conteúdo: ao desfazer uma lista (clicar
      // de novo no botão de lista), o texto do último item simplesmente
      // desaparece em vez de virar parágrafo — bug confirmado do Jodit
      // quando enter="br" (não acontece com o padrão "p"). Revertido.
      // O sticky nativo do Jodit escuta o scroll da JANELA (window), mas
      // quem rola de verdade aqui é o <Layout> interno com overflowY:auto
      // (ver AppLayout.js) — o cálculo do Jodit fica incompatível com isso e
      // ele acaba grudando o próprio toolbar em cima da barra de botões
      // (Publicar, Salvar etc.), que também é sticky. Desliga o sticky
      // nativo do Jodit pra não colidir com a nossa barra.
      toolbarSticky: false,
      // Adicionar corretor ortográfico
      spellcheck: true,
      // Configurações de correção ortográfica
      spellcheckLang: 'pt-BR', // Define o idioma para português brasileiro
      width: "100%",
      minHeight: "400px",
      cleanHTML: {
        // Permitir apenas certas tags (todas as outras serão removidas)
        // Cuidado: Se você definir 'allowTags', apenas as tags listadas serão permitidas.
        // Exemplo:
        // allowTags: {
        //     p: true,
        //     strong: true,
        //     em: true,
        //     a: { href: true, target: true },
        //     ul: true,
        //     ol: true,
        //     li: true,
        //     br: true
        // },

        // Negar certas tags (elas serão removidas)
        //denyTags: {
        //    style: false,   // Remove tags <style>     // Remove tags <p>
        //},

        // Substituir tags antigas por novas
        replaceOldTags: {
          'i': 'em',         // Substitui <i> por <em>
          'b': 'strong',     // Substitui <b> por <strong>
          //'font': 'span'     // Substitui <font> por <span>
        },
        /* cleanAttributes: {
            // Remove o atributo 'style' de todas as tags
            '*': ['style']
        },*/
        removeEmptyElements: true, // Remove elementos vazios
        fillEmptyParagraph: true, // Preencher parágrafos vazios
        removeOnError: true, // Remove elementos que não podem ser limpos
        // Limpar atributos específicos de todas as tags ou de tags específicas
        //clearObjects: true, // Limpa objetos (embeds, iframes, etc.) se não permitidos
      },
      // Forçar todos os links a terem target="_blank"
      // safeHTML: true, // Habilita a sanitização de HTML (útil para prevenir XSS)
      processPasteHTML: true,
      /* events: {
         onCustomPasteHTMLOption: (action, html) => {
           if (action === 'removeFont') {
             let htmlCleaned = html.replace(/<font[^>]*>/gi, '<font');
             htmlCleaned = htmlCleaned.replace(/<span[^>]*>/gi, '<span>');
             htmlCleaned = htmlCleaned.replace(/<p[^>]*>/gi, '<p>');
             console.log("htmlCleaned:", htmlCleaned);
             return htmlCleaned;
           }
           return html;
         }
       },
       pasteHTMLActionList: [
         { text: 'Copiar Conteúdo', value: 'removeFont' }
       ]*/
    }),
    []
  );

  return (
    <Content
      style={{
        // O Layout pai é flex-column com overflow:auto e altura fixa
        // (100vh). O Content é flex:1 1 auto — sem flexShrink:0 ele é
        // espremido pra caber exatamente na altura do container (720px
        // por ex.), mesmo tendo mais conteúdo que isso (overflow:visible
        // só deixa o excesso vazar visualmente, sem alargar a própria
        // caixa). Como o sticky é limitado à caixa do próprio pai, a
        // barra de botões "acaba o espaço" e some ao rolar, apesar da
        // rolagem real (no Layout avô) continuar bem além disso.
        // flexShrink:0 faz o Content crescer pra altura real do conteúdo.
        flexShrink: 0,
        width: "100%",
      }}
    >
      {/* O sticky nativo do Jodit (toolbarSticky) escuta o scroll da JANELA,
          mas quem rola aqui é o <Layout> interno com overflowY:auto — por
          isso ele fica desligado (toolbarSticky:false no config) e o toolbar
          do Jodit vira sticky "na mão" via CSS puro, empilhado logo abaixo
          da barra de botões (que também é sticky), em vez de ficar escondido
          atrás dela ao rolar. */}
      <style>{`
        .rb-editor-sticky-toolbar .jodit-toolbar__box {
          position: sticky;
          top: var(--rb-action-bar-height, 45px);
          z-index: 90;
          background: #fff;
        }
        /* Zoom de leitura: só escala visualmente a área de edição (via
           CSS zoom), o HTML/font-size salvo no conteúdo não é alterado. */
        .rb-editor-sticky-toolbar .jodit-wysiwyg {
          zoom: var(--rb-editor-zoom, 1);
        }
        /* Fidelidade com o que vai ao ar: o texto é salvo com as linhas
           separadas por <br>, que não tem margem nenhuma — mas dentro do
           editor o Jodit usa <p>, que vem com margem do navegador. Era essa
           margem que dava o espaço "fantasma": o redator via o texto arejado
           aqui e ele saía grudado no site. Zerando a margem, a área de edição
           mostra exatamente o resultado final. Para separar blocos, o Enter
           duplo cria uma linha em branco de verdade, que é preservada até o
           ar (ver removerParagrafos/normalizarParaEditor em functions/utils). */
        .rb-editor-sticky-toolbar .jodit-wysiwyg p {
          margin: 0;
        }
      `}</style>
      <DrawerImages
        open={drawer.isOpen}
        onClose={() =>
          setDrawer((prevState) => ({ ...prevState, isOpen: false }))
        }
        data={drawer.data}
      />
      <Modal
        title={capturedChartHtml ? "Inserir Conteúdo" : "Inserir Gráfico de Relatório"}
        open={reportPickerOpen}
        onCancel={closeReportPicker}
        footer={null}
      >
        {capturedChartHtml ? (
          <>
            <Typography.Paragraph>Conteúdo pronto! O que deseja fazer?</Typography.Paragraph>
            <Space>
              <Button type="primary" onClick={confirmInsertReportChart}>
                Inserir no cursor
              </Button>
              <Button onClick={confirmCopyReportChart}>Copiar código</Button>
            </Space>
          </>
        ) : (
          <>
            <Space direction="vertical" style={{ width: "100%" }}>
              {REPORT_CHART_SOURCES.map((source) => (
                <Button
                  key={source.key}
                  block
                  size="large"
                  onClick={() => openReportChartSource(source.path)}
                >
                  {source.label}
                </Button>
              ))}
            </Space>
            <Typography.Paragraph type="secondary" style={{ marginTop: 16 }}>
              Configure o gráfico na janela que abrir e clique em "Copiar"/"Gerar código" — volte
              aqui pra inserir no lugar onde estava o cursor ou só copiar o código.
            </Typography.Paragraph>
          </>
        )}
      </Modal>
      <Modal
        title="Usar Modelo de Matéria"
        open={modeloPickerOpen}
        onCancel={closeModeloPicker}
        footer={null}
        afterOpenChange={(aberto) => aberto && buscaModeloRef.current?.focus()}
      >
        {modelos.length > 0 ? (
          <>
            <Input.Search
              ref={buscaModeloRef}
              allowClear
              placeholder="Buscar modelo pelo título..."
              value={buscaModelo}
              onChange={(e) => setBuscaModelo(e.target.value)}
              style={{ marginBottom: 10 }}
            />
            <Typography.Paragraph type="secondary" style={{ fontSize: 12, marginBottom: 8 }}>
              {modelosFiltrados.length} de {modelos.length} modelo
              {modelos.length === 1 ? "" : "s"}
            </Typography.Paragraph>
            {modelosFiltrados.length > 0 ? (
              // A lista rola dentro do modal: são centenas de modelos, e sem
              // altura máxima o modal crescia até ficar impossível de usar.
              <Space
                direction="vertical"
                style={{ width: "100%", maxHeight: "50vh", overflowY: "auto" }}
              >
                {modelosFiltrados.map((modelo) => (
                  <Button
                    key={modelo.mod_codigo}
                    block
                    size="large"
                    onClick={() => chooseModelo(modelo)}
                    style={{ whiteSpace: "normal", height: "auto", padding: "8px 12px" }}
                  >
                    {modelo.mod_nome}
                  </Button>
                ))}
              </Space>
            ) : (
              <Typography.Paragraph type="secondary">
                Nenhum modelo com esse título.
              </Typography.Paragraph>
            )}
          </>
        ) : (
          <Typography.Paragraph type="secondary">
            Nenhum modelo de matéria cadastrado ainda. Cadastre em "Modelos de Matéria" no menu.
          </Typography.Paragraph>
        )}
      </Modal>
      {agendado && (
        <Alert
          type="info"
          showIcon
          icon={<ClockCircleOutlined />}
          message={`Agendada para publicar em ${scheduleDate ? dayjs(scheduleDate).format("DD/MM/YYYY [às] HH:mm") : ""}`}
          style={{ marginBottom: 12 }}
        />
      )}
      <div
        ref={actionBarRef}
        style={{
          position: "sticky",
          top: 0,
          zIndex: 100,
          background: "#fff",
          padding: "6px 10px",
          display: "flex",
          gap: 8,
          fontSize: "12px",
          alignItems: "center",
          flexWrap: "wrap",
          borderBottom: "1px solid #f0f0f0",
          boxShadow: "0 2px 4px rgba(0,0,0,0.06)",
        }}
      >
        <Button
          size="middle"
          icon={fieldsCollapsed ? <DownOutlined /> : <UpOutlined />}
          onClick={() => setFieldsCollapsed((v) => !v)}
          title={fieldsCollapsed ? "Mostrar campos" : "Recolher campos"}
        />
        {!isPopup && (
          <Button
            size="middle"
            icon={<ExportOutlined />}
            onClick={openPopupEditor}
            title="Abrir em janela cheia"
          />
        )}
        <div style={{ display: "flex", alignItems: "center", gap: 2, border: "1px solid #f0f0f0", borderRadius: 6, padding: "0 2px" }}>
          <Button
            size="middle"
            type="text"
            icon={<ZoomOutOutlined />}
            onClick={() => setZoomLevel((z) => Math.max(70, z - 10))}
            title="Diminuir fonte de leitura do editor"
          />
          <span
            onClick={() => setZoomLevel(100)}
            title="Restaurar 100%"
            style={{ fontSize: 12, minWidth: 34, textAlign: "center", cursor: "pointer", userSelect: "none" }}
          >
            {zoomLevel}%
          </span>
          <Button
            size="middle"
            type="text"
            icon={<ZoomInOutlined />}
            onClick={() => setZoomLevel((z) => Math.min(200, z + 10))}
            title="Aumentar fonte de leitura do editor"
          />
        </div>
        <Button
          color="purple"
          variant="solid"
          size="middle"
          icon={<LineChartOutlined />}
          onMouseDown={saveEditorCursor}
          onClick={openPopupForGrafico}
        >
          Adicionar Gráficos
        </Button>
        <Button
          color="magenta"
          variant="solid"
          size="middle"
          icon={<FileTextOutlined />}
          onMouseDown={saveEditorCursor}
          onClick={openReportPicker}
        >
          Gráfico de Relatório
        </Button>
        {/* O histórico de mapas ganhou botão próprio em vez de ser mais uma
            opção dentro de "Gráfico de Relatório": um mapa de clima não é um
            gráfico de relatório, então ninguém ia procurar por ele ali — o
            que fazia o atalho parecer inexistente. */}
        <Button
          color="blue"
          variant="solid"
          size="middle"
          icon={<BsCloudRainHeavy />}
          onMouseDown={saveEditorCursor}
          onClick={() => openReportChartSource("/clima/historico")}
        >
          Mapas de Clima
        </Button>
        {
          !formattedDate && localStorage.getItem(STORAGE_KEY) !== '{"title":"","secao":"","content":"","tag":"","lead1":"","lead2":"","importancia":"0","optionsAdicional":{"Destaque":false,"Espanhol":false,"Tv":false,"Rel.Research":false,"Rural Biz(G:30)(C:20)":false},"notImagem":null}' && (
            <Button
              onClick={() => { localStorage.removeItem(STORAGE_KEY); navigate(0) }}
              danger
              size="middle"
            >
              Apagar Rascunho
            </Button>)
        }
        {formattedDate && (
          <Button
            type="primary"
            danger
            size="middle"
            icon={<FaTrash />}
            onClick={deleteItem}
            disabled={!accessLevel?.usr_excluir}
            title={
              !accessLevel?.usr_excluir &&
              "Você não tem permissão para excluir"
            }
          >
            Excluir
          </Button>
        )}
        <Button
          type="primary"
          size="middle"
          icon={<FaUpload/>}
          onClick={() => {handleSave(1)}}
          style={{ fontWeight: "bold", marginLeft: "auto" }}
        >
        {/* Numa agendada o botão só salva (o agendamento é preservado),
            então "Atualizar" seria enganoso. */}
        {formattedDate ? (agendado ? "Salvar" : "Atualizar") : "Publicar (Site)"}
        </Button>
        {formattedDate && agendado && (
          <Button
            color="green"
            variant="solid"
            size="middle"
            icon={<FaUpload />}
            onClick={handlePublicarAgora}
            style={{ fontWeight: "bold" }}
          >
            Publicar Agora
          </Button>
        )}
        { !isUpdating && !id && (
        <Button
          color="cyan"
          variant="solid"
          size="middle"
          icon={<FaSave />}
          onClick={() => {handleSave(0)}}
        >
          Salvar (Aprovação)
        </Button>
         )}
        {!showScheduler ? (
          <Button
            color="gold"
            variant="solid"
            size="middle"
            icon={<ClockCircleOutlined />}
            onClick={() => setShowScheduler(true)}
          >
            Agendar Publicação
          </Button>
        ) : (
          <>
            <DatePicker
              showTime
              format="DD/MM/YYYY HH:mm"
              placeholder="Data/hora do agendamento"
              value={scheduleDate}
              onChange={setScheduleDate}
              style={{ minWidth: 200 }}
            />
            <Button
              color="green"
              variant="solid"
              size="middle"
              disabled={!scheduleDate}
              onClick={() => handleSave(0, { agendar: true, dataAgendada: scheduleDate })}
            >
              Confirmar Agendamento
            </Button>
            <Button
              size="middle"
              icon={<CloseOutlined />}
              onClick={() => setShowScheduler(false)}
            />
          </>
        )}
      </div>
      <Descriptions
        title={titlePage}
        bordered
        size="small"
      >
        {!fieldsCollapsed && (
        <Descriptions.Item
          label={"Titulo"}
          span={2}
           size="small"
          children={
            <Input
              style={{ width: "100%" }}
              placeholder="Digite o título da notícia"
              onChange={handleTitleChange}
              value={title}
            />
          }
        />
        )}

        {/*<Descriptions.Item
          label={"Sub-lead 2"}
          span={2}
          children={
            <Input
              style={{ width: "100%" }}
              value={lead2}
              onChange={handleLead2Change}
              placeholder="Digite o título do Sub-lead"
            />
          }
        />*/}
        {/*<Descriptions.Item
          label={"Importância"}
          span={1}
          children={
            <Radio.Group
              defaultValue="0"
              buttonStyle="solid"
              value={importancia}
              onChange={handleImportanciaChange}
            >
              <Radio.Button value="0">
                <LuStarOff />
              </Radio.Button>
              <Radio.Button value="1">
                <LuStar />
              </Radio.Button>
              <Radio.Button value="2">
                <LuStar />
                <LuStar />
              </Radio.Button>
            </Radio.Group>
          }
        />
        <Descriptions.Item
          label={"Seção"}
          span={2}
          children={
            <Select
              placeholder="Selecione uma Seção"
              onChange={handleSecaoChange}
              value={secao}
              style={{ width: "100%" }}
            >
              {optionsSection.map((option) => (
                <Select.Option key={option.value} value={option.value}>
                  {option.label}
                </Select.Option>
              ))}
            </Select>
          }
        />*/}
        {!fieldsCollapsed && (
        <Descriptions.Item
          label={"Seção"}
          span={1}
          size="small"
          children={
            <Select
              placeholder="Selecione uma Seção"
              onChange={handleSecaoChange}
              value={secao}
              style={{ width: "100%" }}
            >
              {optionsSection.map((option) => (
                <Select.Option key={option.value} value={option.value}>
                  {option.label}
                </Select.Option>
              ))}
            </Select>
          }
        />
        )}
        {!fieldsCollapsed && (
        <>
        <Descriptions.Item
          label={"Sub-lead"}
          span={2}
          size="small"
          children={
            <Input
              style={{ width: "100%" }}
              placeholder="Digite o título do Sub-lead"
              value={lead1}
              onChange={handleLead1Change}
            />
          }
        />
        <Descriptions.Item
          label={"Tag"}
          span={1}
          size="small"
          children={
            <Select
              style={{ width: "100%" }}
              placeholder="Selecione uma tag"
              onChange={handleTagChange}
              value={tag}
              showSearch
              filterOption={(input, option) =>
                (option?.label.toLocaleLowerCase() ?? "").includes(
                  input?.toLocaleLowerCase()
                )
              }
              options={optionsTag}
            />
          }
        />
        <Descriptions.Item
          label={"Imagem"}
          span={2}
          children={
            <Space style={{ display: "flex", alignItems: "flex-start" }}>
              {notImagem?.img_arquivo && (
                <Image
                  preview={{ height: "50%" }}
                  height={"70px"}
                  src={`${process.env.REACT_APP_BANCO_IMG_URL}${notImagem?.img_arquivo}`}
                />
              )}
              <Content
                style={{
                  display: "flex",
                  flexDirection: notImagem?.img_arquivo ? "column" : "row",
                  gap: 10,
                }}
              >
                <Button
                  onClick={() => openPopup()}
                  type="primary"
                  disabled={notImagem?.img_arquivo && notImagem.key}
                >
                  {notImagem?.img_arquivo && notImagem.key
                    ? notImagem.img_arquivo
                    : "Escolher imagem"}
                </Button>
                <Button
                  icon={<UploadOutlined />}
                  onClick={() =>
                    setDrawer((prevState) => ({ ...prevState, isOpen: true }))
                  }
                >
                  Adicionar Imagem
                </Button>
                <Button onClick={openModeloPicker}>Usar Modelo</Button>
              </Content>
              {notImagem?.img_arquivo && (
                <Button
                  danger
                  type="primary"
                  icon={<DeleteOutlined />}
                  disabled={!notImagem}
                  onClick={onClearImage}
                />
              )}
            </Space>
          }
        />
        <Descriptions.Item
          label={"Opções Adicionais"}
          span={1}
          size="small"
          children={Object.keys(optionsAdicional).map((key) => (
            <Checkbox
              key={key}
              checked={!!optionsAdicional[key]}
              onChange={(e) =>
                setOptionsAdicional({
                  ...optionsAdicional,
                  [key]: e.target.checked,
                })
              }
            >
              {key}
            </Checkbox>
          ))}
        />
        </>
        )}
      </Descriptions>
      {isLoading ? (
        <Aguarde />
      ) : (
        <div
          className="rb-editor-sticky-toolbar"
          style={{
            //maxWidth: "1000px",
            width: "100%",
            height: "100%",
            minHeight: "100%",
            marginInline: "auto",
            padding: 10,
            "--rb-editor-zoom": zoomLevel / 100,
          }}
        >
          <JoditEditor
            editorRef={setEditorInstance}
            value={content}
            config={joditConfig}
            tabIndex={1}
            onBlur={(newContent) => setContent(newContent)}
          />
        </div>
      )}
    </Content>
  );
}

export default EditorNoticia;
